module.exports = __webpack_public_path__ + "media/case1.41cb1eaa.mp4";